export const FACTORY_TABLE_TEXTS_CONFIG = {
  SORT_ASCEND: 'Нажмите, чтобы отсортировать по возрастанию',
  SORT_DESCEND: 'Нажмите, чтобы отсортировать по убыванию',
};
